"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerStates = void 0;
var Conviva = require("@convivainc/conviva-js-coresdk");
var object_1 = require("../utils/object");
exports.PlayerStates = {
    BUFFERING: "BUFFERING",
    NOT_MONITORED: "NOT_MONITORED",
    PAUSED: "PAUSED",
    PLAYING: "PLAYING",
    STOPPED: "STOPPED",
    UNKNOWN: "UNKNOWN",
};
var ConvivaMonitor = /** @class */ (function () {
    function ConvivaMonitor(jwMonitor, _a) {
        var _b, _c;
        var apiKey = _a.apiKey, logLevel = _a.logLevel, gatewayUrl = _a.gatewayUrl;
        var _this = this;
        this.heartbeatTimeout = null;
        this.playbackRequested = false;
        this.log = function (title, data) {
            if (_this.logLevel !== 0)
                return;
            if (typeof data !== "object")
                return console.log("%c ".concat(title), "font-weight: bold;", data);
            if (!!window.chrome) {
                return console.log.apply(console, __spreadArray(["%c ".concat(title), "font-weight: bold;"], Object.keys(data).reduce(function (acc, key) { return __spreadArray(__spreadArray([], acc, true), ["\n\t- ".concat(key, ":").concat("".padStart(Math.max(28 - key.length, 1))), data[key]], false); }, []), false));
            }
            console.log("%c ".concat(title), "font-weight: bold;");
            Object.keys(data).forEach(function (key) { return console.log("\t- ".concat(key, ":"), data[key]); });
        };
        this.castToStringRecord = function (metadata) {
            return Object.fromEntries(Object.entries(metadata).map(function (_a) {
                var key = _a[0], value = _a[1];
                return [key, value === null ? "" : String(value)];
            }));
        };
        this.getMetadata = function () {
            var _a;
            var _b, _c, _d, _e, _f;
            var trackData = _this.jwMonitor.getTrackData();
            var playlistItem = (_b = _this.jwMonitor.instance) === null || _b === void 0 ? void 0 : _b.getPlaylistItem();
            var source = playlistItem === null || playlistItem === void 0 ? void 0 : playlistItem.sources[0];
            var isLive = trackData.media_duration === 0;
            var hashedVisitorId = ((_c = window.utag) === null || _c === void 0 ? void 0 : _c.data.hashed_visitor_id) || "";
            return __assign((_a = {}, _a[Conviva.Constants.DURATION] = (isLive ? -1 : trackData.media_duration), _a[Conviva.Constants.IS_LIVE] = isLive ? Conviva.Constants.StreamType.LIVE : Conviva.Constants.StreamType.VOD, _a[Conviva.Constants.ASSET_NAME] = trackData.media_id, _a[Conviva.Constants.STREAM_URL] = (source === null || source === void 0 ? void 0 : source.file) || "", _a[Conviva.Constants.PLAYER_NAME] = trackData.player_name, _a[Conviva.Constants.FRAMEWORK_NAME] = "jwplayer", _a[Conviva.Constants.FRAMEWORK_VERSION] = trackData.player_version, _a[Conviva.Constants.DEFAULT_RESOURCE] = "CLOUDFRONT", _a[Conviva.Constants.VIEWER_ID] = hashedVisitorId, _a.media_type = "video", _a.page_url = document.location.href, _a.parent_hostname = document.location.hostname, _a.player_channel = trackData.player_channel, _a.player_type = "jwplayer", _a.tealium_profile_name = ((_d = window.utag) === null || _d === void 0 ? void 0 : _d.data.tealium_profile) || "", _a.app_name = "".concat(window.WXA.defaultLayer.app_name || ""), _a.app_brandname = ((_e = window.utag) === null || _e === void 0 ? void 0 : _e.data.app_brandname) || "", _a.hashed_visitor_id = hashedVisitorId, _a.c_sko_pub = "".concat(((_f = window.utag) === null || _f === void 0 ? void 0 : _f.data.c_sko_pub) || ""), _a), _this.castToStringRecord(playlistItem.metadata));
        };
        this.reportPlaybackRequested = function () {
            if (_this.playbackRequested) {
                return;
            }
            var metadata = _this.getMetadata();
            _this.log("videoAnalytics.reportPlaybackRequested()", metadata);
            _this.videoAnalytics.reportPlaybackRequested(metadata);
            _this.playbackRequested = true;
        };
        this.startHeartbeat = function () {
            _this.log("startConvivaHeartbeat", "");
            if (_this.heartbeatTimeout)
                return;
            _this.heartbeatTimeout = setInterval(function () {
                var _a, _b;
                var _c;
                var isAd = !!_this.jwMonitor.state.ad.event;
                if (isAd) {
                    _this.log("adAnalytics.reportAdMetric()", (_a = {},
                        _a[Conviva.Constants.Playback.PLAY_HEAD_TIME] = _this.jwMonitor.state.ad.position,
                        _a));
                    _this.adAnalytics.reportAdMetric(Conviva.Constants.Playback.PLAY_HEAD_TIME, _this.jwMonitor.state.ad.position);
                    return;
                }
                var _d = _this.jwMonitor.state.video, bufferPercent = _d.bufferPercent, position = _d.position;
                var duration = (_c = _this.jwMonitor.instance) === null || _c === void 0 ? void 0 : _c.getDuration();
                var bufferLength = null;
                if (bufferPercent && duration && position) {
                    bufferLength = Math.max(((bufferPercent * duration) / 100 - position) * 1000, 0);
                }
                _this.log("videoAnalytics.reportPlaybackMetric()", (_b = {},
                    _b[Conviva.Constants.Playback.PLAY_HEAD_TIME] = position,
                    _b[Conviva.Constants.Playback.BUFFER_LENGTH] = bufferLength,
                    _b));
                _this.videoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.PLAY_HEAD_TIME, position);
                if (bufferLength !== null)
                    _this.videoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.BUFFER_LENGTH, bufferLength);
            }, 1000);
        };
        this.stopHeartbeat = function () {
            _this.log("stopConvivaHeartbeat", "");
            if (!_this.heartbeatTimeout)
                return;
            clearInterval(_this.heartbeatTimeout);
            _this.heartbeatTimeout = null;
        };
        this.reportPlaybackMetric = function (metricKey, metricValue) {
            _this.videoAnalytics.reportPlaybackMetric(metricKey, metricValue);
            if (metricKey === Conviva.Constants.Playback.PLAYER_STATE) {
                if (metricValue === exports.PlayerStates.PLAYING || metricValue === exports.PlayerStates.BUFFERING)
                    return _this.startHeartbeat();
                _this.stopHeartbeat();
            }
        };
        this.reportPlaybackEnded = function () {
            _this.stopHeartbeat();
            _this.log("reportPlaybackEnded", "");
            _this.videoAnalytics.reportPlaybackEnded();
            _this.playbackRequested = false;
        };
        this.reportPlaybackError = function (errorMessage, type) {
            _this.videoAnalytics.reportPlaybackError(errorMessage, type);
        };
        this.reportAdBreakStarted = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            (_a = _this.videoAnalytics).reportAdBreakStarted.apply(_a, args);
        };
        this.reportAdBreakEnded = function () {
            _this.videoAnalytics.reportAdBreakEnded();
        };
        this.reportAdStarted = function (adEvent) {
            var _a;
            _this.log("reportAdStarted", adEvent);
            var customTags = __assign({}, adEvent);
            Object.keys(customTags).forEach(function (key) {
                if (key.startsWith("event_") || key === "ad") {
                    delete customTags[key];
                }
            });
            var metadata = __assign(__assign(__assign({}, _this.getMetadata()), (_a = {}, _a[Conviva.Constants.DURATION] = adEvent.ad_duration, _a[Conviva.Constants.IS_LIVE] = Conviva.Constants.StreamType.VOD, _a[Conviva.Constants.ASSET_NAME] = adEvent.ad_id, _a[Conviva.Constants.STREAM_URL] = null, _a[Conviva.Constants.DEFAULT_RESOURCE] = null, _a)), customTags);
            (0, object_1.deleteNullValues)(metadata);
            _this.log("adAnalytics.reportAdStarted()", metadata);
            _this.adAnalytics.reportAdStarted(metadata);
        };
        this.reportAdMetric = function (metricKey, metricValue) {
            _this.adAnalytics.reportAdMetric(metricKey, metricValue);
            if (metricKey === Conviva.Constants.Playback.PLAYER_STATE) {
                if (metricValue === exports.PlayerStates.PLAYING || metricValue === exports.PlayerStates.BUFFERING)
                    return _this.startHeartbeat();
                _this.stopHeartbeat();
            }
        };
        this.reportAdEnded = function () {
            _this.adAnalytics.reportAdEnded();
        };
        this.reportAdError = function (errorMessage, type) {
            _this.adAnalytics.reportAdError(errorMessage, type);
        };
        this.cleanup = function () {
            _this.videoAnalytics.release();
            Conviva.Analytics.release();
        };
        this.jwMonitor = jwMonitor;
        this.logLevel = logLevel;
        var settings = (_b = {},
            _b[Conviva.Constants.GATEWAY_URL] = gatewayUrl,
            _b[Conviva.Constants.LOG_LEVEL] = logLevel,
            _b);
        Conviva.Analytics.init(apiKey, null, settings);
        var deviceMetadata = (_c = {},
            _c[Conviva.Constants.DeviceMetadata.CATEGORY] = Conviva.Constants.DeviceCategory.WEB,
            _c);
        Conviva.Analytics.setDeviceMetadata(deviceMetadata);
        this.videoAnalytics = Conviva.Analytics.buildVideoAnalytics();
        this.adAnalytics = Conviva.Analytics.buildAdAnalytics();
    }
    return ConvivaMonitor;
}());
exports.default = ConvivaMonitor;
